import {
  type FormatCurrencyOptions,
  type NumericInput,
} from "~/lib/display-format";
import { cn } from "~/lib/utils";
import { useMarketValueFormatter } from "~/lib/value-format";

/**
 * USD price display that compresses micro-cap leading zeros into
 * CoinGecko-style subscript notation: 0.000000000000131 renders as
 * $0.0₁₁131 (a true <sub> element, smaller than Unicode subscripts).
 * Ordinary prices render exactly like formatCurrency.
 */
export function SubscriptCurrency({
  className,
  options,
  value,
}: {
  className?: string;
  options?: FormatCurrencyOptions;
  value: NumericInput;
}) {
  const marketValueFormatter = useMarketValueFormatter();
  const parts = marketValueFormatter.subscriptCurrencyParts(value, options);

  if (parts.subscriptZeroCount === null) {
    return <span className={className}>{parts.text}</span>;
  }

  return (
    <span aria-label={parts.text} className={cn("tabular-nums", className)}>
      <span aria-hidden="true">
        {parts.prefix}
        <sub className="text-[0.65em] font-medium">
          {parts.subscriptZeroCount}
        </sub>
        {parts.digits}
        {parts.suffix}
      </span>
    </span>
  );
}
